"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopBar = exports.topBarHeight = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const AppBar_1 = __importDefault(require("@material-ui/core/AppBar"));
const Container_1 = __importDefault(require("@material-ui/core/Container"));
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
const useTheme_1 = __importDefault(require("@material-ui/core/styles/useTheme"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const useMediaQuery_1 = __importDefault(require("@material-ui/core/useMediaQuery"));
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const react_google_login_1 = require("../react-google-login");
const gatsby_image_1 = __importDefault(require("gatsby-image"));
const InvertColors_1 = __importDefault(require("@material-ui/icons/InvertColors"));
const ThemeProvider_1 = require("./ThemeProvider");
exports.topBarHeight = (theme) => theme.spacing(8);
const useStyles = makeStyles_1.default(theme => ({
    top: {
        position: "fixed",
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary,
    },
    container: {
        height: exports.topBarHeight(theme),
        display: "flex",
        alignItems: "center",
    },
    image: {
        height: theme.spacing(6),
        width: theme.spacing(6),
        marginRight: theme.spacing(2),
        flexShrink: 0,
    },
}));
exports.TopBar = ({ title, logo }) => {
    const classes = useStyles();
    const theme = useTheme_1.default();
    const { colorScheme, setColorScheme } = ThemeProvider_1.useColorScheme();
    const thin = useMediaQuery_1.default(theme.breakpoints.down("sm"));
    return (react_1.default.createElement(AppBar_1.default, { className: classes.top },
        react_1.default.createElement(Container_1.default, { maxWidth: "md", className: classes.container },
            logo && react_1.default.createElement(gatsby_image_1.default, { fadeIn: false, fixed: logo, className: classes.image }),
            react_1.default.createElement(Typography_1.default, { variant: "h3", component: "div", noWrap: true, style: { flex: 1 } },
                react_1.default.createElement("code", null, title)),
            react_1.default.createElement(IconButton_1.default, { onClick: () => {
                    setColorScheme(colorScheme === "light" ? "dark" : "light");
                } },
                react_1.default.createElement(InvertColors_1.default, null)),
            react_1.default.createElement(react_google_login_1.LoginButton, { iconOnly: thin }))));
};
exports.TopBar.propTypes = {
    title: prop_types_1.default.node.isRequired,
    logo: prop_types_1.default.any,
};
//# sourceMappingURL=TopBar.js.map